export default {
  choose_preferred_wallet: "원하는 지갑을 선택하세요",
  connect_mobile_wallet: "모바일 지갑과 연결",
  scan_qrcode_with_wallet: "WalletConnect 지원 지갑에서 QR코드를 스캔하세요",
  return_to_mobile_options: "모바일 지갑 옵션으로 돌아가기",
  view_qrcode_option: "QR 코드 보기",
  connect: "연결",
};
